<template>
  <v-menu
    bottom
    offset-y
    left>
    <v-btn
      slot="activator"
      flat
      small
      icon>
      <v-icon>mdi-settings</v-icon>
    </v-btn>
    <v-card class="settings-card">
      <template v-for="(group, groupIndex) in groups">
        <v-divider
          v-if="groupIndex > 0"
          :key="`divider-${groupIndex}`" />

        <div
          :key="`group-${groupIndex}`"
          class="settings-options pt-2 pb-2">
          <v-flex
            v-for="(setting, index) in group"
            :key="index"
            xs4 class="settings-option"
            @click="gotoRouterName(setting.route)">

            <v-icon>{{ setting.icon }}</v-icon>
            <span class="mt-1 setting-title text-xs-center">{{setting.title}}</span>
          </v-flex>
        </div>
      </template>
    </v-card>
  </v-menu>
</template>

<script>
import { settingsNav } from '@/components/base/adminMenu';

export default {
  name: 'SettingsMenu',
  props: {
    // Links promovidos da barra superior quando ela colapsa em telas estreitas.
    extraItems: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    groups() {
      return [this.extraItems, settingsNav].filter(group => group.length);
    },
  },
  methods: {
    gotoRouterName(name) {
      this.$router.push({ name });
    },
  },
};
</script>

<style lang="scss">
  h3 {
    margin-bottom: 15px;
  }

  .settings-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 310px;
  }

  .settings-options {
    display: flex;
    flex-wrap: wrap;
  }

  .settings-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 8px !important;
  }

  .setting-title {
    font-size: 10px;
  }
</style>
